import { FC, useEffect, useState } from 'react';
import { Box, FormControl, MenuItem, Select, SelectChangeEvent, TextField, TextFieldProps } from '@mui/material';
import moment, { Moment } from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AvaSuburbHours, FutureOrderDateTimes, TradingHoursReturnType } from '@models';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import InputLabel from '@mui/material/InputLabel';
import { getAvailableFutureDeliveryTimes } from '@helpers';

type Props = {
  deliverySuburb: AvaSuburbHours;
  onSelect: (dateTime: FutureOrderDateTimes) => void;
};

export const EcomTradingDateTimePicker: FC<Props> = ({ deliverySuburb, onSelect }) => {
  const [selectedDate, setSelectedDate] = useState<Moment>(moment());
  const [times, setTimes] = useState<TradingHoursReturnType[]>([]);

  useEffect(() => {
    const newTimes = getAvailableFutureDeliveryTimes(selectedDate, deliverySuburb);

    setTimes(newTimes);
  }, [deliverySuburb, selectedDate]);

  const handleTimeSelect = (event: SelectChangeEvent) => {
    onSelect({
      requested_delivery_time: event.target.value,
      requested_delivery_end_time: moment(event.target.value).add(30, 'minute').toISOString(true),
    });
  };

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      <Box flex={1}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            value={selectedDate}
            label="Delivery Date *"
            minDate={moment()}
            maxDate={moment().add(1, 'month')}
            onChange={(newValue: Moment | null) => {
              if (newValue) {
                setSelectedDate(newValue);
              }
            }}
            inputFormat="DD/MM/YYYY"
            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
              <TextField {...params} data-testid="ecom-date-picker" fullWidth />
            )}
            InputAdornmentProps={{ ...({ 'data-testid': 'ecom-date-picker-icon' } as any) }}
          />
        </LocalizationProvider>
      </Box>
      <FormControl fullWidth>
        <InputLabel id="time-picker-label">Delivery Time *</InputLabel>
        <Select labelId="time-picker-label" label="Delivery Time *" onChange={handleTimeSelect} data-testid="ecom-trading-time-picker">
          {times.map((time) => (
            <MenuItem value={time.value}>{time.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
